/**
 * Jarvis R-A: meldet dem Server echte Nutzereingaben (Klick, Taste, Tippen, Scrollen), gedrosselt.
 * Der Server beendet Sitzungen nach 15 Minuten ohne diese Meldung. Hintergrundabfragen, SSE und
 * WebSocket melden nichts - sie verlaengern die Sitzung nicht.
 */
export const ACTIVITY_EVENTS = ["pointerdown", "keydown", "wheel", "touchstart"] as const
export const MIN_INTERVAL_MS = 30_000

export interface ReporterOptions {
  getToken: () => string | null
  onExpired: () => void
  fetchFn?: (url: string, init: RequestInit) => Promise<Response>
  now?: () => number
  visible?: () => boolean
}

export function createActivityReporter(opts: ReporterOptions): () => void {
  let last = 0
  const fetchFn = opts.fetchFn ?? ((url, init) => fetch(url, init))
  const now = opts.now ?? Date.now
  const visible = opts.visible ?? (() => typeof document === "undefined" || document.visibilityState === "visible")
  return () => {
    const token = opts.getToken()
    if (!token || !visible()) return
    const t = now()
    if (t - last < MIN_INTERVAL_MS) return
    last = t
    void fetchFn("/api/session/activity", { method: "POST", headers: { Authorization: `Bearer ${token}` } })
      .then((res) => {
        if (res.status === 401) opts.onExpired()
      })
      .catch(() => undefined)
  }
}
